import template from "./template";
function templateHelper(list, ...args) {
  return (list ?? []).map(item => template(item, ...args));
}

export default templateHelper;
